import clsx from "clsx";
import React from "react";

type SectionHeaderProps = {
  title: string;
  desc?: string;
  sectionHeaderClasses?: string;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  desc,
  sectionHeaderClasses = "",
}) => {
  return (
    <div
      className={clsx(
        "w-full bg-[#F3F3F8] linear-border p-3 custom-shadow",
        sectionHeaderClasses
      )}
    >
      <div className="w-full section-header-bg custom-shadow flex items-center justify-between p-3 rounded-2xl">
        <h2 className="text-[2.23vw] font-luxora-medium  max-lg:text-[6.4vw]  leading-[1.1] text-black ">
          {title}
        </h2>
        {desc && (
          <p className="bg-[#F3F3F8] h-[3vw] max-lg:hidden px-6 flex items-center text-[#665BFF] text-16 leading-[1.1] custom-shadow rounded-xl">
            {desc}
          </p>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
